module.exports = __webpack_public_path__ + "img/emoji_spritesheet_1.6cbaf42a.png";